<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Mes descriptions</p>
</div>

<? if( total ) { ?>
	<div class="py-2 px-3 bb">
		<p class="mb-0 text-center text-secondary small">Vos visites, de la plus récente à la plus ancienne</p>
	</div>
<? } ?>

<div class="visit-list">
	<? _.each( visit_list, function( visit ) { ?>
		<a href="#<?=visit.toUrl('visit/view')?>" class="list-group-item list-group-item-action">
			<div class="d-flex justify-content-between align-items-center">
				<div class="d-flex align-items-center">
					<? /* Vignette small de la mare, ou blank si absente */ ?>
					<img src="<?=visit.get('small') || 'img/photo_blank.png'?>" alt="" class="visit-thumb mr-3" width="76" height="76" />
					<div>
						<p class="mb-1">
							<span class="badge badge-dark badge-md fw-400">Mare #<?=visit.get('pond_id') || '…'?></span>
						</p>
						<p class="mb-0">
							<span class="small fw-600"><?=visit.get('city_name') || '—'?></span>
							<br/><span class="small text-secondary">Visite du <?=visit.getDate('date')?></span>
						</p>
					</div>
				</div>
				<div><?-visit.getIcon()?></div>
			</div>
		</a>
	<? }) ?>

	<? if( !total ) { ?>
		<em class="list-group-item disabled text-center">
			Aucune description trouvée
		</em>
		<div class="p-3 bb">
			<a href="#pond/search" class="btn btn-green btn-block">Décrire une mare</a>
		</div>
	<? } ?>
</div>

<? if( total > page_size ) { ?>
	<div class="p-3 d-flex justify-content-between align-items-center bb bt">
		<? if( has_prev ) { ?>
			<a href="#visit/mine/<?=page - 1?>" class="btn btn-sm btn-outline-secondary">Précédent</a>
		<? } else { ?>
			<span class="btn btn-sm btn-outline-secondary disabled">Précédent</span>
		<? } ?>
		<span class="small text-secondary">Page <?=page?> / <?=page_count?></span>
		<? if( has_next ) { ?>
			<a href="#visit/mine/<?=page + 1?>" class="btn btn-sm btn-outline-secondary">Suivant</a>
		<? } else { ?>
			<span class="btn btn-sm btn-outline-secondary disabled">Suivant</span>
		<? } ?>
	</div>
<? } ?>
